module.exports = __webpack_public_path__ + "img/icon-change.555e39d4.svg";